export type { Locale } from "@i18n/react";
export {
  DEFAULT_LOCALE,
  I18nMessage,
  locales,
  useFormatter,
  useLocale,
  useTranslations,
  useDateFormatter,
} from "@i18n/react";

export { usePathname } from "./hooks/usePathname";
export { useSetLocale } from "./hooks/useSetLocale";
export type { LinkProps } from "./lib/navigation";
export {
  getPathname,
  Link,
  permanentRedirect,
  redirect,
  useRouter,
} from "./lib/navigation";
export { routing } from "./lib/routing";
export { I18nProvider } from "./providers/I18nProvider";
export { basei18n } from "./utils/basei18n";
export { getLocalesAsParams } from "./utils/getLocalesAsParams";
